import ThemeProvider from './src/common/themes/theme-provider/theme-provider.tsx';
import PageProvider from './src/common/providers/pageProvider/page-provider.tsx';

export const wrapRootElement = ThemeProvider;

export const wrapPageElement = PageProvider;

export const onRouteUpdate = () => {
  if (process.env.NODE_ENV === 'production') {
    setTimeout(() => {
      const data = window.dataLayer;
      if (data) {
        data.push({ event: 'gatsby-route-change' });
      }
    }, 50);
  }
};
